module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.account && Object.keys(_vm.account).length > 0) ? _c('shared-product-provide', {
    attrs: {
      "product": _vm.product,
      "fromModule": _vm.fromModule,
      "toModule": _vm.toModule
    }
  }, [_c('panel', [_c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('tikTokShop.shop.label'),
      "required": true,
      "disabled": _vm.disabledInputs(),
      "error": _vm.getError('selectedAuthorizedShop', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedAuthorizedShop),
      expression: "selectedAuthorizedShop"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedAuthorizedShop = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione uma loja")]), _vm._v(" "), _vm._l((_vm.authorizedShops), function(authorizedShop) {
    return _c('option', {
      key: authorizedShop.identifier,
      domProps: {
        "value": authorizedShop
      }
    }, [_vm._v("\n            " + _vm._s(authorizedShop.nickname) + "\n          ")])
  })], 2)]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": _vm.$t('tikTokShop.warehouse.label'),
      "required": true,
      "disabled": _vm.disabledInputs(),
      "error": _vm.getError('selectedWarehouse', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedWarehouse),
      expression: "selectedWarehouse"
    }],
    staticClass: "form-select",
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedWarehouse = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione um centro de distribuição")]), _vm._v(" "), _vm._l((_vm.warehouses), function(warehouse) {
    return _c('option', {
      key: warehouse.id,
      domProps: {
        "value": warehouse
      }
    }, [_vm._v("\n            " + _vm._s(warehouse.name) + "\n          ")])
  })], 2)])], 1)]), _vm._v(" "), (!_vm.loading) ? _c('div', {
    staticClass: "c-box"
  }, [_c('loader', {
    attrs: {
      "loading": _vm.sending,
      "label": _vm.getCountVariations()
    }
  }), _vm._v(" "), _c('header', {
    staticClass: "c-box__heading",
    class: {
      disabledHeader: _vm.product.status === 'cannotSend'
    },
    on: {
      "click": function($event) {
        return _vm.toggleProductInfo()
      }
    }
  }, [_vm._m(0), _vm._v(" "), _c('i', {
    staticClass: "u-floatRight icon",
    class: _vm.toggleIconClass()
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.show && !_vm.everyVariationWithErrorOrSent),
      expression: "show && !everyVariationWithErrorOrSent"
    }],
    staticClass: "c-box__body"
  }, [_c('div', {
    staticClass: "c-box__inner"
  }, [(_vm.product) ? _c('panel', {
    attrs: {
      "title": "Informações gerais do produto"
    }
  }, [_c('div', {
    attrs: {
      "slot": "header-right"
    },
    slot: "header-right"
  }, [_c('button', {
    staticClass: "hint hint--left btn btn--info",
    class: {
      'is-loading': _vm.addingImage
    },
    attrs: {
      "disabled": _vm.addingImage,
      "data-label": "Adicionar uma imagem em uma ou mais variações"
    },
    on: {
      "click": function($event) {
        _vm.addingImage = true
      }
    }
  }, [_vm._v("\n              Adicionar Imagem\n            ")]), _vm._v(" "), _c('modal-add-image', {
    attrs: {
      "visible": _vm.addingImage,
      "variations": _vm.product.variations,
      "callback": _vm.uploadedImage,
      "module": _vm.moduleUploadImageModal
    },
    on: {
      "close": function (close) { return _vm.addingImage = close; }
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "slot": "product",
      "label": "Título",
      "columns": 12,
      "error": _vm.getError('title', _vm.product.productId),
      "required": true
    },
    slot: "product"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.title),
      expression: "product.title"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabledInput('title')
    },
    domProps: {
      "value": (_vm.product.title)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "title", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.maxTitleLengthDI !== null) ? _c('small', {
    staticClass: "form-help",
    class: _vm.titleLength
  }, [_vm._v(_vm._s(_vm.getTitleLengthLabel()))]) : _vm._e()]), _vm._v(" "), _c('form-group', {
    attrs: {
      "slot": "product",
      "label": "Descrição",
      "columns": 12,
      "error": _vm.getError('description', _vm.product.productId),
      "required": true
    },
    slot: "product"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.product.description),
      expression: "product.description"
    }],
    staticClass: "form-textarea",
    attrs: {
      "rows": "8",
      "disabled": _vm.disabledInput('description')
    },
    domProps: {
      "value": (_vm.product.description)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.product, "description", $event.target.value)
      }
    }
  }), _vm._v(" "), (_vm.maxDescriptionLengthDI !== null) ? _c('small', {
    staticClass: "form-help",
    class: _vm.descriptionLength
  }, [_vm._v(_vm._s(_vm.getDescriptionLengthLabel()))]) : _vm._e()]), _vm._v(" "), _vm._t("default")], 2), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": "Buscar categorias",
      "required": true,
      "disabled": _vm.disabledInputs(),
      "error": _vm.getError('selectedCategory', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.categorySearch),
      expression: "categorySearch"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "Digite para buscar..."
    },
    domProps: {
      "value": (_vm.categorySearch)
    },
    on: {
      "blur": _vm.handleCategorySearch,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleCategorySearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.categorySearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Categoria do produto",
      "required": true,
      "disabled": _vm.disabledInputs(),
      "error": _vm.getError('selectedCategory', _vm.product.productId)
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingCategories
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select-wrapper"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedCategory),
      expression: "selectedCategory"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.loadingCategories
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedCategory = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v(_vm._s(_vm.categoryPlaceholder))]), _vm._v(" "), _vm._l((_vm.categories), function(category) {
    return _c('option', {
      key: category.id,
      domProps: {
        "value": category
      }
    }, [_vm._v("\n                    " + _vm._s(category.name) + "\n                  ")])
  })], 2)])], 1), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Buscar marcas",
      "required": true,
      "disabled": _vm.disabledInputs(),
      "error": _vm.getError('selectedBrand', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.brandSearch),
      expression: "brandSearch"
    }],
    staticClass: "form-input",
    attrs: {
      "placeholder": "Digite para buscar..."
    },
    domProps: {
      "value": (_vm.brandSearch)
    },
    on: {
      "blur": _vm.handleBrandSearch,
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.handleBrandSearch.apply(null, arguments)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.brandSearch = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Marca do produto",
      "required": true,
      "disabled": _vm.disabledInputs(),
      "error": _vm.getError('selectedBrand', _vm.product.productId)
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingBrands
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select-wrapper"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedBrand),
      expression: "selectedBrand"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.loadingBrands
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedBrand = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione uma marca")]), _vm._v(" "), _vm._l((_vm.brands), function(brand) {
    return _c('option', {
      key: brand.id,
      domProps: {
        "value": brand
      }
    }, [_vm._v("\n                    " + _vm._s(brand.name) + "\n                  ")])
  })], 2)])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "l-row"
  }, [_c('form-group', {
    attrs: {
      "label": _vm.$t('crossDocking.label'),
      "error": _vm.getError('crossDocking', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.crossDocking),
      expression: "crossDocking"
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.crossDocking)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.crossDocking = $event.target.value
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("(Em dias)")])])], 1)]) : _vm._e(), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Requisitos da categoria"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingCategoryRules
    }
  }), _vm._v(" "), (!_vm.selectedCategory && !_vm.loadingCategoryRules) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('p', {
    staticClass: "placeholder-msg"
  }, [_vm._v("Selecione a categoria para exibir os requisitos da categoria.")])])]) : (_vm.hasCategoryRequirements && !_vm.loadingCategoryRules) ? _c('div', {
    staticClass: "l-row"
  }, [(_vm.must('package_dimension')) ? [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Dimensões do pacote")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Comprimento",
      "columns": 3,
      "required": true,
      "error": _vm.getError('requirements.package_dimension.length', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.requirements.package_dimension.length),
      expression: "requirements.package_dimension.length",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "Ex: 20",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.requirements.package_dimension.length)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requirements.package_dimension, "length", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Largura",
      "columns": 3,
      "required": true,
      "error": _vm.getError('requirements.package_dimension.width', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.requirements.package_dimension.width),
      expression: "requirements.package_dimension.width",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "Ex: 15",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.requirements.package_dimension.width)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requirements.package_dimension, "width", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Altura",
      "columns": 3,
      "required": true,
      "error": _vm.getError('requirements.package_dimension.height', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.requirements.package_dimension.height),
      expression: "requirements.package_dimension.height",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "Ex: 10",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.requirements.package_dimension.height)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requirements.package_dimension, "height", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Peso do pacote",
      "columns": 3,
      "required": true,
      "error": _vm.getError('requirements.package_dimension.packageWeight', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (_vm.requirements.package_dimension.packageWeight),
      expression: "requirements.package_dimension.packageWeight",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "number",
      "min": "0",
      "placeholder": "Ex: 0.5",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.requirements.package_dimension.packageWeight)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requirements.package_dimension, "packageWeight", _vm._n($event.target.value))
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('small', {
    staticClass: "form-help"
  }, [_vm._v("(Peso em gramas)")])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Unidade",
      "columns": 3,
      "required": true,
      "error": _vm.getError('requirements.package_dimension.unit', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requirements.package_dimension.unit),
      expression: "requirements.package_dimension.unit"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.requirements.package_dimension, "unit", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "CM"
    }
  }, [_vm._v("CM")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "INCH"
    }
  }, [_vm._v("INCH")])])])] : _vm._e(), _vm._v(" "), (_vm.must('manufacturer')) ? _c('form-group', {
    attrs: {
      "label": "Fabricante",
      "columns": 6,
      "required": true,
      "error": _vm.getError('requirements.manufacturer', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.requirements.manufacturer),
      expression: "requirements.manufacturer",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "Informe o fabricante",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.requirements.manufacturer)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requirements, "manufacturer", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.must('epr')) ? _c('form-group', {
    attrs: {
      "label": "EPR (nº/identificação)",
      "columns": 6,
      "required": true,
      "error": _vm.getError('requirements.epr', _vm.product.productId)
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.requirements.epr),
      expression: "requirements.epr",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "Informe o EPR exigido",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.requirements.epr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requirements, "epr", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.must('cod')) ? _c('form-group', {
    attrs: {
      "label": "COD (Cash on Delivery)",
      "columns": 6,
      "required": true,
      "error": _vm.getError('requirements.cod', _vm.product.productId)
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.requirements.cod),
      expression: "requirements.cod"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.requirements, "cod", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    domProps: {
      "value": true
    }
  }, [_vm._v("Sim")]), _vm._v(" "), _c('option', {
    domProps: {
      "value": false
    }
  }, [_vm._v("Não")])])]) : _vm._e(), _vm._v(" "), (_vm.must('responsible_person')) ? [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Responsável pelo produto")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Nome",
      "columns": 4
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.requirements.responsible_person.name),
      expression: "requirements.responsible_person.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "Nome completo",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.requirements.responsible_person.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requirements.responsible_person, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Telefone",
      "columns": 4
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.requirements.responsible_person.phone),
      expression: "requirements.responsible_person.phone",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "text",
      "placeholder": "(DDD) 00000-0000",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.requirements.responsible_person.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requirements.responsible_person, "phone", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "E-mail",
      "columns": 4
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.requirements.responsible_person.email),
      expression: "requirements.responsible_person.email",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-input",
    attrs: {
      "type": "email",
      "placeholder": "email@exemplo.com",
      "disabled": _vm.disabledInputs()
    },
    domProps: {
      "value": (_vm.requirements.responsible_person.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.requirements.responsible_person, "email", $event.target.value.trim())
      },
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.must('size_chart')) ? [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Guia de tamanho")])])]), _vm._v(" "), _c('form-group', {
    attrs: {
      "label": "Guia de tamanho",
      "columns": 3,
      "required": true,
      "error": _vm.getError('requirements.size_chart', _vm.product.productId)
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingSizeCharts
    }
  }), _vm._v(" "), (!_vm.loadingSizeCharts) ? _c('div', [(_vm.sizeCharts.length) ? _c('div', {
    staticClass: "select-wrapper"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedSizeChart),
      expression: "selectedSizeChart"
    }],
    staticClass: "form-select",
    attrs: {
      "disabled": _vm.disabledInputs()
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedSizeChart = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Selecione uma guia de tamanho")]), _vm._v(" "), _vm._l((_vm.sizeCharts), function(chart) {
    return _c('option', {
      key: chart.template_id,
      domProps: {
        "value": chart
      }
    }, [_vm._v("\n                        " + _vm._s(chart.template_name) + "\n                      ")])
  })], 2)]) : _c('p', {
    staticClass: "placeholder-msg"
  }, [_vm._v("A categoria precisa de uma guia de tamanho. Nenhuma guia de tamanho cadastrada na loja. Por favor, cadastre uma guia de tamanho no Marketplace.")]), _vm._v(" "), (_vm.selectedSizeChart && _vm.selectedSizeChart.images && _vm.selectedSizeChart.images.length) ? _c('img', {
    staticClass: "size-chart-preview",
    attrs: {
      "src": _vm.selectedSizeChart.images[0].url,
      "alt": _vm.selectedSizeChart.template_name
    }
  }) : _vm._e()]) : _vm._e()], 1)] : _vm._e(), _vm._v(" "), (_vm.productCertRulesRequired.length) ? [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Certificações exigidas")])])]), _vm._v(" "), _vm._l((_vm.requirements.product_certifications), function(cert, idx) {
    return _c('div', {
      key: 'cert-' + idx,
      staticClass: "l-col-12@md"
    }, [_c('div', {
      staticClass: "c-box__inner",
      staticStyle: {
        "padding": "8px 0"
      }
    }, [_c('strong', [_vm._v(_vm._s(cert.name || ('Certificação #' + (idx + 1))))]), _vm._v(" "), _c('div', {
      staticClass: "l-row"
    }, [_c('form-group', {
      attrs: {
        "label": "Detalhes do documento",
        "columns": 6,
        "required": true,
        "error": _vm.getError(("requirements.product_certifications[" + idx + "].document_details"), _vm.product.productId)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (cert.document_details),
        expression: "cert.document_details",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "placeholder": "Resumo/identificação do documento",
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (cert.document_details)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cert, "document_details", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]), _vm._v(" "), (cert.expiration_date && cert.expiration_date.is_required) ? _c('form-group', {
      attrs: {
        "label": "Data de expiração",
        "columns": 3,
        "required": true,
        "error": _vm.getError(("requirements.product_certifications[" + idx + "].expiration_date.value"), _vm.product.productId)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (cert.expiration_date.value),
        expression: "cert.expiration_date.value"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "date",
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (cert.expiration_date.value)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cert.expiration_date, "value", $event.target.value)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (cert.sample_image_url) ? _c('form-group', {
      attrs: {
        "label": "URL da imagem/extrato",
        "columns": 6,
        "required": true,
        "error": _vm.getError(("requirements.product_certifications[" + idx + "].sample_image_url_user"), _vm.product.productId)
      }
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model.trim",
        value: (cert.sample_image_url_user),
        expression: "cert.sample_image_url_user",
        modifiers: {
          "trim": true
        }
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "placeholder": "https://link-da-imagem-ou-arquivo",
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (cert.sample_image_url_user)
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(cert, "sample_image_url_user", $event.target.value.trim())
        },
        "blur": function($event) {
          return _vm.$forceUpdate()
        }
      }
    })]) : _vm._e()], 1)])])
  })] : _vm._e()], 2) : (_vm.selectedCategory && !_vm.loadingCategoryRules) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('p', {
    staticClass: "placeholder-msg"
  }, [_vm._v("Esta categoria não possui requisitos obrigatórios.")])])]) : _vm._e()], 1), _vm._v(" "), _c('panel', {
    attrs: {
      "title": "Atributos"
    }
  }, [_c('loader', {
    attrs: {
      "loading": _vm.loadingAttributes
    }
  }), _vm._v(" "), (!_vm.selectedCategory && !_vm.loadingAttributes) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('p', {
    staticClass: "placeholder-msg"
  }, [_vm._v("Selecione a categoria para exibir os atributos.")])])]) : (_vm.attributes.length) ? _c('div', {
    staticClass: "l-row"
  }, _vm._l((_vm.productOnlyAttributes), function(attribute) {
    return _c('form-group', {
      key: attribute.id,
      attrs: {
        "label": attribute.name,
        "required": attribute.isRequired,
        "columns": 6,
        "error": _vm.getError(String(attribute.id), _vm.product.productId)
      }
    }, [(attribute.isMultipleSelection) ? _c('multiselect', {
      attrs: {
        "options": attribute.values || [],
        "track-by": "id",
        "label": "name",
        "multiple": true,
        "close-on-select": false,
        "clear-on-select": false,
        "hide-selected": true,
        "taggable": !!attribute.isCustomizable,
        "placeholder": _vm.getAttributePlaceholder(attribute),
        "disabled": _vm.disabledInputs()
      },
      on: {
        "tag": function (val) { return _vm.addCustomTagProduct(attribute, val); }
      },
      model: {
        value: (attribute.value),
        callback: function($$v) {
          _vm.$set(attribute, "value", $$v)
        },
        expression: "attribute.value"
      }
    }) : (attribute.values && attribute.values.length && attribute.isMultipleSelection === false) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.id]),
        expression: "product.attributes[attribute.id]"
      }],
      staticClass: "form-select",
      attrs: {
        "disabled": _vm.disabledInputs()
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.product.attributes, attribute.id, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": ""
      },
      domProps: {
        "value": null
      }
    }, [_vm._v(_vm._s(_vm.getAttributePlaceholder(attribute)))]), _vm._v(" "), _vm._l((attribute.values), function(value) {
      return _c('option', {
        key: value.id,
        domProps: {
          "value": value
        }
      }, [_vm._v("\n                  " + _vm._s(value.name) + "\n                ")])
    })], 2) : _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.product.attributes[attribute.id]),
        expression: "product.attributes[attribute.id]"
      }],
      staticClass: "form-input",
      attrs: {
        "type": "text",
        "placeholder": _vm.getAttributePlaceholder(attribute),
        "disabled": _vm.disabledInputs()
      },
      domProps: {
        "value": (_vm.product.attributes[attribute.id])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.product.attributes, attribute.id, $event.target.value)
        }
      }
    })], 1)
  }), 1) : (_vm.selectedCategory && !_vm.loadingAttributes) ? _c('div', {
    staticClass: "l-row"
  }, [_c('div', {
    staticClass: "l-col-12@md"
  }, [_c('p', {
    staticClass: "placeholder-msg"
  }, [_vm._v("Esta categoria não possui atributos configuráveis.")])])]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "divider"
  }, [_c('span', [_vm._v("Informações das variações do produto")])]), _vm._v(" "), _c('div', {
    staticClass: "l-row vertical-flex"
  }, _vm._l((_vm.product.variations), function(variation) {
    return _c('div', {
      key: variation.sku || variation.id,
      staticClass: "l-col-12@md"
    }, [_c('MarketplaceProvideVariationTikTokShop', {
      attrs: {
        "variation": variation,
        "from-module": _vm.fromModule,
        "to-module": _vm.toModule,
        "variation-attributes": _vm.variationAttributes,
        "loading-variation-attributes": _vm.loadingAttributes,
        "account": {
          identifier: _vm.account.identifier
        }
      }
    })], 1)
  }), 0)], 1)])], 1) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_vm._v(_vm._s(_vm.product.title))])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-51ee27b0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/marketplace/tiktokshop/provide/Product.vue
// module id = 3165
// module chunks = 0